import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from '@/pages/HomePage'
import LoginPage from '@/pages/LoginPage'
import CallbackPage from '@/pages/CallbackPage'
import PasswordResetEmailPage from '@/pages/PasswordResetEmailPage'
import PasswordResetPage from '@/pages/PasswordResetPage'
import EmailValidationPage from '@/pages/EmailValidationPage'

import DashboardPage from '@/pages/DashboardPage'
import CoursePage from '@/pages/CoursePage'
import ModulePage from '@/pages/ModulePage'
import ResourcePage from '@/pages/ResourcePage'
import ResourcesPage from '@/pages/ResourcesPage'

import AstronautProgramPage from '@/pages/AstronautProgramPage'
import KinderPage from '@/pages/KinderPage'
import PDPage from '@/pages/PDPage'
import FutureExplorersPage from '@/pages/FutureExplorersPage'
import ManualPage from '@/pages/ManualPage'
import ManualContentPage from '@/pages/ManualContentPage'
import EducatorPage from '@/pages/EducatorPage'
import TrainerPage from '@/pages/TrainerPage'
import ClassroomPage from '@/pages/ClassroomPage'
// import DigitalPage from '@/pages/DigitalPage'
import OnlinePage from '@/pages/OnlinePage'
import OnsitePage from '@/pages/OnsitePage'
import SeminarsPage from '@/pages/SeminarsPage'
// import AboutUsPage from '@/pages/AboutUsPage'
import PrivacyPage from '@/pages/PrivacyPage'
import TermsofUse from '@/pages/TermsOfUse'
import ContactPage from '@/pages/ContactPage'
import TestimoniesPage from '@/pages/TestimoniesPage'
import ProfilePage from '@/pages/ProfilePage'
import FLPage from '@/pages/FLPage'
import FLApproachPage from '@/pages/FLApproachPage'
import FLTeamPage from '@/pages/FLTeamPage'
import CampsPage from '@/pages/CampsPage'
import ServicePage from '@/pages/ServicePage'
import RegisterPage from '@/pages/RegisterPage'

import {store} from '@/store/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/password-reset-email',
    name: 'password-reset-email',
    component: PasswordResetEmailPage
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    component: PasswordResetPage
  },
  {
    path: '/email-validation',
    name: 'email-validation',
    component: EmailValidationPage
  },
  {
    path: '/callback',
    name: 'callback',
    component: CallbackPage
  },
  {
    path: '/courses/:courseId/:langId',
    name: 'course',
    component: CoursePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/courses/:courseId/:langId/modules/:moduleId/lessons/:lessonId',
    name: 'lesson',
    component: ModulePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/astronaut-program',
    name: 'astronaut-program',
    component: AstronautProgramPage
  },
  {
    path: '/resources',
    name: 'resources',
    component: ResourcesPage
  },
  {
    path: '/resources/:id',
    name: 'resource',
    component: ResourcePage
  },
  {
    path: '/kindergarten',
    name: 'kinder',
    component: KinderPage
  },
  {
    path: '/professional-development',
    name: 'prof-dev',
    component: PDPage
  },
  {
    path: '/future-explorers',
    name: 'future-explorers',
    component: FutureExplorersPage
  },
  {
    path: '/manual',
    name: 'manual',
    component: ManualPage
  },
  {
    path: '/educator-training',
    name: 'educator',
    component: EducatorPage
  },
  {
    path: '/trainer-training',
    name: 'trainer',
    component: TrainerPage
  },
  {
    path: '/classroom',
    name: 'classroom',
    component: ClassroomPage
  },
  // {
  //   path: '/digital-tools',
  //   name: 'digital-tools',
  //   component: DigitalPage
  // },
  {
    path: '/online',
    name: 'online',
    component: OnlinePage
  },
  {
    path: '/onsite',
    name: 'onsite',
    component: OnsitePage
  },
  {
    path: '/seminars',
    name: 'seminars',
    component: SeminarsPage
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: FLPage
  },
  {
    path: '/approach',
    name: 'approach',
    component: FLApproachPage
  },
  {
    path: '/team',
    name: 'team',
    component: FLTeamPage
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPage
  },
  {
    path: '/termsofuse',
    name: 'termsofuse',
    component: TermsofUse
  },
  {
    path: '/testimonies',
    name: 'testimonies',
    component: TestimoniesPage
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactPage
  },
  {
    path: '/camps',
    name: 'camps',
    component: CampsPage
  },
  {
    path: '/service/:id',
    name: 'service',
    component: ServicePage
  },
  {
    path: '/register/:jotform',
    name: 'register',
    component: RegisterPage
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/manual/:section/:unit?/:week?/:lesson?',
    name: 'manualContent',
    component: ManualContentPage,
    meta: { requiresAuth: true }
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.isAuthenticated) {
      next({
        path: '/login'
        // query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js